/* istanbul ignore file */

import { isBrowser } from '@noths/polaris-client-feature-capabilities';
import bunyan from 'bunyan';
import getConfig from 'next/config';

import { NextConfig } from '../types/NextConfig';

const { serviceName } = (getConfig() as NextConfig).publicRuntimeConfig.datadog;

export const logger = isBrowser()
  ? (console as unknown as bunyan)
  : bunyan.createLogger({
      name: serviceName,
    });
